import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';

/**
 * NotificationBell Component
 * 
 * What: Simple notification bell button that redirects to notifications page
 * Why: Users need quick access to notifications without dropdown complexity
 * Where: Used in header next to user profile dropdown
 */
export const NotificationBell = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/notifications');
  };

  return (
    <button
      className="p-3 rounded-lg text-gray-600 hover:bg-gray-200 relative"
      onClick={handleClick}
      aria-label="View notifications"
    >
      <Bell className="h-5 w-5" />
      {/* Notification indicator dot */}
      <span className="absolute top-2 right-2 block h-2 w-2 rounded-full bg-error-400"></span>
    </button>
  );
};
